// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Gen from "../Control.Monad.Gen/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_CodePoint_Unicode from "../Data.CodePoint.Unicode/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Gen from "../Data.String.Gen/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Parsing.functorParserT);
var bind = /* #__PURE__ */ Control_Bind.bind(Parsing.bindParserT);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showChar);
var show1 = /* #__PURE__ */ Data_Show.show(Data_String_CodePoints.showCodePoint);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var Lambda = /* #__PURE__ */ (function () {
    function Lambda() {

    };
    Lambda.value = new Lambda();
    return Lambda;
})();
var Identifier = /* #__PURE__ */ (function () {
    function Identifier(value0) {
        this.value0 = value0;
    };
    Identifier.create = function (value0) {
        return new Identifier(value0);
    };
    return Identifier;
})();
var Dot = /* #__PURE__ */ (function () {
    function Dot() {

    };
    Dot.value = new Dot();
    return Dot;
})();
var OpenParen = /* #__PURE__ */ (function () {
    function OpenParen() {

    };
    OpenParen.value = new OpenParen();
    return OpenParen;
})();
var CloseParen = /* #__PURE__ */ (function () {
    function CloseParen() {

    };
    CloseParen.value = new CloseParen();
    return CloseParen;
})();
var render = function (lex) {
    var v = (function () {
        if (lex instanceof Lambda) {
            return new Data_Tuple.Tuple("lambda", "\\");
        };
        if (lex instanceof Identifier) {
            return new Data_Tuple.Tuple("identifier", lex.value0);
        };
        if (lex instanceof Dot) {
            return new Data_Tuple.Tuple("dot", ".");
        };
        if (lex instanceof OpenParen) {
            return new Data_Tuple.Tuple("openParen", "(");
        };
        if (lex instanceof CloseParen) {
            return new Data_Tuple.Tuple("closeParen", ")");
        };
        throw new Error("Failed pattern match at Lexeme (line 102, column 5 - line 107, column 43): " + [ lex.constructor.name ]);
    })();
    var cLexeme = function (c) {
        return "lexeme_" + c;
    };
    var cType = function (c) {
        return cLexeme("tag_" + c);
    };
    return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.classes([ cLexeme("display"), cType(v.value0) ]) ])([ Halogen_HTML_Core.text(v.value1) ]);
};
var renderMany = function (dictFunctor) {
    var map2 = Data_Functor.map(dictFunctor);
    return function (dictFoldable) {
        var fromFoldable = Data_Array.fromFoldable(dictFoldable);
        return function (ls) {
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("lexemes_display") ])(fromFoldable(map2(render)(ls)));
        };
    };
};
var print = function (v) {
    if (v instanceof Lambda) {
        return Data_String_CodeUnits.singleton("\\");
    };
    if (v instanceof Identifier) {
        return v.value0;
    };
    if (v instanceof Dot) {
        return Data_String_CodeUnits.singleton(".");
    };
    if (v instanceof OpenParen) {
        return Data_String_CodeUnits.singleton("(");
    };
    if (v instanceof CloseParen) {
        return Data_String_CodeUnits.singleton(")");
    };
    throw new Error("Failed pattern match at Lexeme (line 76, column 1 - line 76, column 26): " + [ v.constructor.name ]);
};
var printMany = function (dictFoldable) {
    var foldr = Data_Foldable.foldr(dictFoldable);
    return function (ls) {
        var alg = function (l) {
            return function (leadingId) {
                return function (t) {
                    if (l instanceof Identifier) {
                        return new Data_Tuple.Tuple(true, (function () {
                            if (leadingId) {
                                return l.value0 + " ";
                            };
                            return l.value0;
                        })() + t);
                    };
                    return new Data_Tuple.Tuple(false, print(l) + t);
                };
            };
        };
        return Data_Tuple.snd(foldr(function ($97) {
            return Data_Tuple.uncurry(alg($97));
        })(new Data_Tuple.Tuple(false, ""))(ls));
    };
};
var identifier = /* #__PURE__ */ Parsing_Combinators["try"](/* #__PURE__ */ map(Data_String_CodeUnits.fromCharArray)(/* #__PURE__ */ Data_Array.some(Parsing.alternativeParserT)(Parsing.lazyParserT)(/* #__PURE__ */ Parsing_String.satisfy(function ($98) {
    return Data_CodePoint_Unicode.isLetter(Data_String_CodePoints.codePointFromChar($98));
}))));
var parser = /* #__PURE__ */ (function () {
    return Data_Foldable.oneOf(Data_Foldable.foldableArray)(Parsing.plusParserT)([ voidRight(Lambda.value)(Parsing_String["char"]("\\")), voidRight(Dot.value)(Parsing_String["char"](".")), voidRight(OpenParen.value)(Parsing_String["char"]("(")), voidRight(CloseParen.value)(Parsing_String["char"](")")), map(Identifier.create)(identifier), bind(Parsing_String.anyChar)(function (badChar) {
        return Parsing.fail("Bad input character: " + show(badChar));
    }), bind(Parsing_String.anyCodePoint)(function (badCode) {
        return Parsing.fail("Bad input code point (!): " + show1(badCode));
    }) ]);
})();
var genericLexeme = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Lambda.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Identifier(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Dot.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return OpenParen.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return CloseParen.value;
        };
        throw new Error("Failed pattern match at Lexeme (line 44, column 1 - line 44, column 50): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Lambda) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Identifier) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Dot) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof OpenParen) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof CloseParen) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Lexeme (line 44, column 1 - line 44, column 50): " + [ x.constructor.name ]);
    }
};
var showLexeme = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLexeme)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Lambda";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Identifier";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Dot";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "OpenParen";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "CloseParen";
        }
    }))))))
};
var generator = function (dictMonadRec) {
    var genAlphaString = Data_String_Gen.genAlphaString(dictMonadRec);
    return function (dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        return Control_Monad_Gen.oneOf(dictMonadGen)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray)(Data_Array_NonEmpty["cons$prime"](Data_Functor.map(((Monad0.Bind1()).Apply0()).Functor0())(Identifier.create)(genAlphaString(dictMonadGen)))(map1(Control_Applicative.pure(Monad0.Applicative0()))([ Lambda.value, Dot.value, OpenParen.value, CloseParen.value ])));
    };
};
var eqLexeme = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Lambda && y instanceof Lambda) {
                return true;
            };
            if (x instanceof Identifier && y instanceof Identifier) {
                return x.value0 === y.value0;
            };
            if (x instanceof Dot && y instanceof Dot) {
                return true;
            };
            if (x instanceof OpenParen && y instanceof OpenParen) {
                return true;
            };
            if (x instanceof CloseParen && y instanceof CloseParen) {
                return true;
            };
            return false;
        };
    }
};
var eq1 = /* #__PURE__ */ Data_Eq.eq(eqLexeme);
var checkParsePrint = function (x) {
    return Data_Either.either(Data_Function["const"](false))(function (v) {
        return eq1(x)(v);
    })(Parsing.runParser(print(x))(parser));
};
export {
    Lambda,
    Identifier,
    Dot,
    OpenParen,
    CloseParen,
    generator,
    parser,
    print,
    printMany,
    checkParsePrint,
    render,
    renderMany,
    eqLexeme,
    genericLexeme,
    showLexeme
};
//# sourceMappingURL=index.js.map
